import { Calendar } from "primereact/calendar";
import { classNames } from "primereact/utils";
import localeText from "../../../../../locale";
import { PERIODS } from "../hooks/useReport";

const PRESETS = [
  { value: PERIODS.ALL, labelKey: "all" },
  { value: PERIODS.THIS_MONTH, labelKey: "adminReportsThisMonth" },
  { value: PERIODS.LAST_MONTH, labelKey: "adminReportsLastMonth" },
  { value: PERIODS.THIS_YEAR, labelKey: "adminReportsThisYear" },
];

// Período (atalhos + intervalo personalizado) e exportação em PDF
const ReportToolbar = ({ report }) => {
  const { period, customRange, changePeriod, downloadPdf, downloading, loading } = report;

  return (
    <div className="admin-report__toolbar">
      <div className="admin-report__period">
        <div className="admin-home-period__segmented" role="group" aria-label={localeText("filters")}>
          {PRESETS.map((preset) => (
            <button
              key={preset.value}
              type="button"
              className={classNames("admin-home-period__option", {
                "admin-home-period__option--active": period === preset.value,
              })}
              aria-pressed={period === preset.value}
              onClick={() => changePeriod(preset.value)}
            >
              {localeText(preset.labelKey)}
            </button>
          ))}
        </div>
        <Calendar
          value={period === PERIODS.CUSTOM ? customRange : null}
          onChange={(e) => {
            // Só aplica quando as duas datas do intervalo foram escolhidas
            if (e.value?.[0] && e.value?.[1]) changePeriod(PERIODS.CUSTOM, e.value);
          }}
          selectionMode="range"
          readOnlyInput
          showIcon
          maxDate={new Date()}
          dateFormat="dd/mm/yy"
          placeholder={localeText("adminHomeCustomPeriod")}
          className={classNames("admin-list__calendar", {
            "admin-home-period__calendar--active": period === PERIODS.CUSTOM,
          })}
        />
      </div>
      <button
        type="button"
        className="admin-btn"
        onClick={downloadPdf}
        disabled={downloading || loading}
      >
        <i className={downloading ? "pi pi-spin pi-spinner" : "pi pi-file-pdf"} aria-hidden="true" />
        {localeText("adminReportsExportPdf")}
      </button>
    </div>
  );
};

export default ReportToolbar;
